<audio id="remote-audio" autoplay playsinline></audio>

<div class="ext-picker-screen" *ngIf="!myExt">
  <div class="ext-picker-hero">
    <div class="ext-picker-logo">
      <span class="material-icons">headset_mic</span>
    </div>
    <h2>Select your extension</h2>
    <p>Choose an available SIP extension to connect this browser as an agent console.</p>
  </div>

  <div class="ext-picker-toolbar">
    <button type="button" class="picker-refresh-btn" (click)="csrCall.fetchExtensionPool()">
      <span class="material-icons">refresh</span>
      Refresh
    </button>
  </div>

  <div class="ext-picker-grid">
    <button
      type="button"
      class="ext-card"
      *ngFor="let ext of extensionPool"
      [class.ext-card-mine]="ext.reservedByMe"
      [class.ext-card-busy]="ext.status !== 'AVAILABLE' && !ext.reservedByMe"
      (click)="csrCall.reserveAndSelect(ext.extensionNumber)"
      [disabled]="ext.status !== 'AVAILABLE' && !ext.reservedByMe"
    >
      <span
        class="ext-card-dot"
        [class.dot-available]="ext.status === 'AVAILABLE'"
        [class.dot-mine]="ext.reservedByMe"
        [class.dot-busy]="ext.status !== 'AVAILABLE' && !ext.reservedByMe"
      ></span>
      <span class="material-icons ext-card-icon">settings_phone</span>
      <span class="ext-card-num">{{ ext.extensionNumber }}</span>
      <span class="ext-card-status">{{ ext.reservedByMe ? 'Reserved by you' : ext.status }}</span>
    </button>
  </div>

  <p class="ext-picker-hint">Only available or already reserved-by-you extensions can be selected.</p>
</div>

<section class="agent-console-root" *ngIf="myExt">
  <div class="agent-toast" *ngIf="toast">{{ toast }}</div>

  <header class="agent-statusbar">
    <div class="agent-brand">
      <span class="material-icons">support_agent</span>
      <div>
        <p>Officer Console</p>
        <h1>Agent Desktop</h1>
      </div>
    </div>

    <div class="agent-status-meta">
      <div class="agent-state-pill" [ngClass]="agentStateClass">
        <span class="material-icons">{{ isActive ? 'call' : ringing ? 'ring_volume' : 'radio_button_checked' }}</span>
        {{ agentStateLabel }}
      </div>
      <div class="agent-ext-pill">
        <span>Ext</span>
        <strong>{{ myExt }}</strong>
      </div>
      <div class="agent-ext-pill">
        <span>SIP</span>
        <strong>{{ sipStatus }}</strong>
      </div>
      <div class="agent-timer" *ngIf="isActive || onHold">
        <span class="material-icons">timer</span>
        {{ mm }}:{{ ss }}
      </div>
    </div>

    <div class="agent-status-actions">
      <button type="button" (click)="goToHistory()">
        <span class="material-icons">history</span>
        History
      </button>
      <button type="button" (click)="changeExtension()">
        <span class="material-icons">swap_horiz</span>
        Change Ext
      </button>
    </div>
  </header>

  <main class="agent-shell">
    <aside class="agent-panel agent-left-panel">
      <div class="panel-tabs">
        <button type="button" [class.active]="activeLeftTab === 'dialpad'" (click)="activeLeftTab = 'dialpad'">
          <span class="material-icons">dialpad</span>
          Dialpad
        </button>
        <button type="button" [class.active]="activeLeftTab === 'directory'" (click)="activeLeftTab = 'directory'">
          <span class="material-icons">contacts</span>
          Directory
        </button>
      </div>

      <section class="dialpad-card" *ngIf="activeLeftTab === 'dialpad'">
        <div class="dial-display">
          <label for="dialpad-number">Number or extension</label>
          <div class="dial-display-input">
            <input
              id="dialpad-number"
              type="text"
              inputmode="tel"
              [ngModel]="dialPadValue"
              (ngModelChange)="syncDialInput($event)"
              (keyup.enter)="handleDial()"
              placeholder="Enter extension or phone number"
            />
            <button type="button" (click)="backspaceDial()" [disabled]="!dialPadValue" aria-label="Backspace">
              <span class="material-icons">backspace</span>
            </button>
          </div>
        </div>

        <div class="dialpad-grid" aria-label="Dialpad">
          <button type="button" class="dial-key" (click)="appendDialDigit('1')">1<span></span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('2')">2<span>ABC</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('3')">3<span>DEF</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('4')">4<span>GHI</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('5')">5<span>JKL</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('6')">6<span>MNO</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('7')">7<span>PQRS</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('8')">8<span>TUV</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('9')">9<span>WXYZ</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('*')">*</button>
          <button type="button" class="dial-key" (click)="appendDialDigit('0')">0<span>+</span></button>
          <button type="button" class="dial-key" (click)="appendDialDigit('#')">#</button>
        </div>

        <div class="dialpad-actions">
          <button type="button" class="dial-clear" (click)="clearDial()" [disabled]="!dialPadValue">
            Clear
          </button>
          <button type="button" class="dial-call-primary" (click)="handleDial()" [disabled]="!dialPadValue.trim()">
            <span class="material-icons">call</span>
            Call
          </button>
        </div>

        <div class="quick-directory">
          <div class="quick-directory__header">
            <span>Available contacts</span>
            <button type="button" (click)="refreshDirectory()" aria-label="Refresh directory">
              <span class="material-icons">refresh</span>
            </button>
          </div>

          <button
            type="button"
            class="quick-agent-row"
            *ngFor="let ext of filteredExtensions.slice(0, 6)"
            (click)="syncDialInput(ext.ext)"
          >
            <span class="presence-dot" [class.busy]="!ext.canCall"></span>
            <span class="quick-agent-main">
              <strong>{{ ext.name || ('Ext ' + ext.ext) }}</strong>
              <small>{{ ext.ext }}</small>
            </span>
            <span class="quick-agent-status">{{ ext.statusLabel }}</span>
          </button>
        </div>
      </section>

      <section class="directory-card" *ngIf="activeLeftTab === 'directory'">
        <div class="directory-toolbar">
          <div>
            <p>Directory</p>
            <span>{{ filteredExtensions.length }} extensions</span>
          </div>
          <button type="button" (click)="refreshDirectory()" aria-label="Refresh directory">
            <span class="material-icons">refresh</span>
          </button>
        </div>

        <input
          class="directory-search"
          type="text"
          [ngModel]="dialInput"
          (ngModelChange)="syncDialInput($event)"
          placeholder="Search extension or name"
        />

        <div class="directory-list">
          <div class="directory-row" *ngFor="let ext of filteredExtensions">
            <span class="presence-dot" [class.busy]="!ext.canCall"></span>
            <div>
              <strong>{{ ext.name || ('Ext ' + ext.ext) }}</strong>
              <small>{{ ext.ext }}</small>
            </div>
            <span class="directory-state">{{ ext.statusLabel }}</span>
            <button type="button" (click)="syncDialInput(ext.ext); handleDial()" [disabled]="!ext.canCall">
              <span class="material-icons">call</span>
            </button>
          </div>
        </div>
      </section>
    </aside>

    <section class="call-stage">
      <div class="call-stage-header">
        <div>
          <p class="stage-kicker">Live interaction</p>
          <h2>{{ callTitle }}</h2>
          <span>{{ callSubtitle }}</span>
        </div>
        <div class="stage-timer" *ngIf="isActive">
          <span class="material-icons">schedule</span>
          {{ mm }}:{{ ss }}
        </div>
      </div>

      <div class="stage-card idle-card" *ngIf="isIdle && sipStatus === 'registered'">
        <div class="call-orb">
          <span class="material-icons">headset_mic</span>
        </div>
        <h3>Ready for calls</h3>
        <p>Incoming calls will appear here with answer, reject, transfer, conference and wrap-up controls.</p>
        <div class="stage-actions">
          <button type="button" class="soft-button" (click)="activeLeftTab = 'dialpad'">
            <span class="material-icons">dialpad</span>
            Open dialpad
          </button>
          <button type="button" class="soft-button" (click)="refreshDirectory()">
            <span class="material-icons">sync</span>
            Refresh directory
          </button>
        </div>
      </div>

      <div class="stage-card offline-card" *ngIf="isIdle && sipStatus !== 'registered'">
        <div class="call-orb muted">
          <span class="material-icons">cloud_off</span>
        </div>
        <h3>Connecting extension {{ myExt }}</h3>
        <p>SIP status: {{ sipStatus }}</p>
      </div>

      <div class="stage-card incoming-card" *ngIf="ringing">
        <div class="call-pulse"></div>
        <div class="caller-avatar-xl">{{ initials(activeCallerName || activeCallerNumber) }}</div>
        <p class="stage-kicker">Incoming call</p>
        <h3>{{ activeCallerName || 'Unknown caller' }}</h3>
        <p>{{ activeCallerNumber || caller }}</p>
        <div class="incoming-actions">
          <button type="button" class="decline-btn" (click)="handleEndCall()">
            <span class="material-icons">call_end</span>
            Decline
          </button>
          <button type="button" class="answer-btn" (click)="csrCall.answerCall()">
            <span class="material-icons">call</span>
            Answer
          </button>
        </div>
      </div>

      <div class="stage-card incoming-card" *ngIf="isDialing">
        <div class="call-pulse outgoing"></div>
        <div class="caller-avatar-xl">{{ initials(activeCallerName || activeCallerNumber) }}</div>
        <p class="stage-kicker">Outbound call</p>
        <h3>{{ activeCallerNumber || dialInput }}</h3>
        <p>Calling from extension {{ myExt }}</p>
        <div class="incoming-actions single">
          <button type="button" class="decline-btn" (click)="handleEndCall()">
            <span class="material-icons">call_end</span>
            Cancel
          </button>
        </div>
      </div>

      <div class="active-call-layout" *ngIf="isActive">
        <section class="active-card">
          <div class="call-status-strip" [class.hold]="onHold">
            <span class="material-icons">{{ onHold ? 'pause_circle' : 'call' }}</span>
            {{ onHold ? 'Customer on hold' : 'Call in progress' }}
          </div>

          <div class="call-party-row">
            <div class="caller-avatar-xl compact">{{ initials(activeCallerName || activeCallerNumber) }}</div>
            <div>
              <p class="stage-kicker">Connected party</p>
              <h3>{{ activeCallerName || 'Unknown caller' }}</h3>
              <span>{{ activeCallerNumber || caller }}</span>
            </div>
          </div>

          <div class="conference-banner" *ngIf="conferenceParticipants.length">
            <span class="material-icons">groups</span>
            <div>
              <strong>Conference active</strong>
              <p>{{ conferenceParticipants.length }} participants connected.</p>
            </div>
          </div>

          <div class="coaching-banner" *ngIf="beingCoached">
            <span class="material-icons">record_voice_over</span>
            Supervisor {{ coachingSupervisor }} is coaching this call.
          </div>

          <div class="coaching-banner monitor" *ngIf="isCoaching">
            <span class="material-icons">visibility</span>
            You are coaching {{ coachingAgent }}.
          </div>

          <div class="call-controls-grid">
            <button type="button" class="call-control" (click)="handleMute()">
              <span class="material-icons">{{ muted ? 'mic_off' : 'mic' }}</span>
              {{ muted ? 'Unmute' : 'Mute' }}
            </button>
            <button type="button" class="call-control" (click)="handleHold()">
              <span class="material-icons">{{ onHold ? 'play_arrow' : 'pause' }}</span>
              {{ onHold ? 'Resume' : 'Hold' }}
            </button>
            <button type="button" class="call-control" (click)="handleRecording()" [class.active]="recording">
              <span class="material-icons">{{ recording ? 'stop_circle' : 'fiber_manual_record' }}</span>
              {{ recording ? 'Stop rec' : 'Record' }}
            </button>
            <button type="button" class="call-control" (click)="showTransfer = true">
              <span class="material-icons">call_split</span>
              Transfer
            </button>
            <button type="button" class="call-control" (click)="showConference = true">
              <span class="material-icons">group_add</span>
              Conference
            </button>
            <button type="button" class="call-control" (click)="activeLeftTab = 'dialpad'">
              <span class="material-icons">dialpad</span>
              Keypad
            </button>
            <button type="button" class="call-control" (click)="handleCaptions()" [class.active]="captionsEnabled">
              <span class="material-icons">closed_caption</span>
              Captions
            </button>
            <button type="button" class="call-control danger" (click)="handleEndCall()">
              <span class="material-icons">call_end</span>
              End
            </button>
          </div>
        </section>

        <section class="notes-card">
          <div class="notes-card__header">
            <div>
              <p class="stage-kicker">Agent notes</p>
              <h3>Interaction notes</h3>
            </div>
            <span>Draft saves automatically</span>
          </div>
          <textarea
            [(ngModel)]="wrapNote"
            (ngModelChange)="onNotesInput()"
            placeholder="Capture caller request, action taken, reference number or escalation details"
          ></textarea>
        </section>
      </div>

      <div class="stage-card wrapup-complete-card" *ngIf="ended">
        <div class="call-orb muted">
          <span class="material-icons">task_alt</span>
        </div>
        <h3>Call ended</h3>
        <p>Complete the wrap-up details before taking the next interaction.</p>
        <button type="button" class="answer-btn" (click)="activeRightTab = 'wrapup'">
          <span class="material-icons">assignment_turned_in</span>
          Open wrap-up
        </button>
      </div>
    </section>

    <aside class="agent-panel agent-right-panel">
      <div class="panel-tabs">
        <button type="button" [class.active]="activeRightTab === 'context'" (click)="activeRightTab = 'context'">
          <span class="material-icons">badge</span>
          Context
        </button>
        <button type="button" [class.active]="activeRightTab === 'transcript'" (click)="activeRightTab = 'transcript'">
          <span class="material-icons">chat_bubble_outline</span>
          Transcript
        </button>
        <button type="button" [class.active]="activeRightTab === 'wrapup'" (click)="activeRightTab = 'wrapup'">
          <span class="material-icons">fact_check</span>
          Wrap-up
        </button>
      </div>

      <section class="context-card" *ngIf="activeRightTab === 'context'">
        <div class="context-hero">
          <div class="caller-avatar-lg">{{ initials(activeCallerName || activeCallerNumber || myExt) }}</div>
          <div>
            <p>{{ isIdle ? 'No active caller' : 'Caller profile' }}</p>
            <h3>{{ activeCallerName || activeCallerNumber || 'Waiting for interaction' }}</h3>
            <span>{{ activeCallerNumber || 'Extension ' + myExt }}</span>
          </div>
        </div>

        <div class="context-row">
          <span>Current state</span>
          <strong>{{ agentStateLabel }}</strong>
        </div>
        <div class="context-row">
          <span>Agent extension</span>
          <strong>{{ myExt }}</strong>
        </div>
        <div class="context-row" *ngIf="caller.callerLanguage">
          <span>Caller language</span>
          <strong>{{ caller.callerLanguage === 'ur' ? 'Urdu' : 'English' }}</strong>
        </div>
        <div class="context-row" *ngIf="caller.ivrOption">
          <span>IVR path</span>
          <strong>{{ caller.ivrOptionLabel || caller.ivrOption }}</strong>
        </div>
        <div class="context-row">
          <span>Recording</span>
          <strong>{{ recording ? 'Active' : 'Off' }}</strong>
        </div>
        <div class="context-row" *ngIf="lastRecordingUrl">
          <span>Last recording</span>
          <a [href]="lastRecordingUrl" target="_blank" rel="noopener">Open</a>
        </div>

        <div class="participant-list" *ngIf="conferenceParticipants.length">
          <p>Conference participants</p>
          <div class="participant-row" *ngFor="let participant of conferenceParticipants">
            <span class="material-icons">person</span>
            <div>
              <strong>{{ participant.ext }}</strong>
              <small>{{ participant.role }}</small>
            </div>
          </div>
        </div>

        <div class="conference-invite" *ngIf="incomingConferenceInfo">
          <p>Conference invite</p>
          <strong>{{ incomingConferenceInfo.initiatorName || incomingConferenceInfo.initiatorExt }} invited you to join.</strong>
          <div>
            <button type="button" class="answer-btn" (click)="csrCall.answerCall()">
              <span class="material-icons">call</span>
              Join
            </button>
            <button type="button" class="decline-btn" (click)="handleEndCall()">
              <span class="material-icons">call_end</span>
              Decline
            </button>
          </div>
        </div>
      </section>

      <section class="transcript-card" *ngIf="activeRightTab === 'transcript'">
        <div class="right-section-header">
          <div>
            <p>Transcript</p>
            <span>Live conversation activity</span>
          </div>
          <button type="button" (click)="handleCaptions()" [class.active]="captionsEnabled">
            <span class="material-icons">closed_caption</span>
          </button>
        </div>

        <div class="transcript-list">
          <div class="transcript-item" *ngFor="let message of transcript">
              <span>{{ message.initials }}</span>
            <div>
              <strong>{{ message.text }}</strong>
              <small>{{ message.time }}</small>
            </div>
          </div>
          <div #chatEnd></div>
        </div>

        <div class="caption-list" *ngIf="captions.length">
          <p>Captions</p>
          <div *ngFor="let line of captions">{{ line.text }}</div>
          <div #captionEnd></div>
        </div>
      </section>

      <section class="wrapup-card" *ngIf="activeRightTab === 'wrapup'">
        <div class="right-section-header">
          <div>
            <p>Wrap-up</p>
            <span>Disposition and follow-up</span>
          </div>
        </div>

        <div class="wrapup-grid">
          <label>
            Disposition
            <select [(ngModel)]="wrapUpDetails.disposition">
              <option value="">Select disposition</option>
              <option *ngFor="let option of dispositionOptions" [value]="option">{{ option }}</option>
            </select>
          </label>
          <label>
            Reason
            <select [(ngModel)]="wrapUpDetails.callReason">
              <option value="">Select reason</option>
              <option *ngFor="let option of callReasonOptions" [value]="option">{{ option }}</option>
            </select>
          </label>
          <label>
            Source
            <select [(ngModel)]="wrapUpDetails.sourceOfInformation">
              <option value="">Select source</option>
              <option *ngFor="let option of sourceOptions" [value]="option">{{ option }}</option>
            </select>
          </label>
          <label>
            Callback
            <input type="datetime-local" [(ngModel)]="wrapUpDetails.callbackDueAt" />
          </label>
        </div>

        <label class="wrapup-notes">
          Notes
          <textarea
            [(ngModel)]="wrapNote"
            (ngModelChange)="onNotesInput()"
            placeholder="Summarize outcome, escalation and next action"
          ></textarea>
        </label>

        <button type="button" class="wrapup-save" (click)="handleWrapUp()">
          <span class="material-icons">save</span>
          Save wrap-up
        </button>
      </section>
    </aside>
  </main>
</section>

<div class="agent-dialog-backdrop" *ngIf="showTransfer" (click)="showTransfer = false">
  <div class="agent-dialog handoff-dialog" role="dialog" aria-modal="true" aria-labelledby="transfer-dialog-title" (click)="$event.stopPropagation()">
    <div class="agent-dialog-header">
      <div class="agent-dialog-title">
        <span class="material-icons">call_split</span>
        <div>
          <p>Warm handoff</p>
          <h3 id="transfer-dialog-title">Transfer call</h3>
        </div>
      </div>
      <button type="button" class="agent-dialog-close" (click)="showTransfer = false" aria-label="Close transfer dialog">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="handoff-summary">
      <div class="caller-avatar-lg">{{ initials(activeCallerName || activeCallerNumber) }}</div>
      <div>
        <p>Connected caller</p>
        <strong>{{ activeCallerName || 'Unknown caller' }}</strong>
        <span>{{ activeCallerNumber || caller }}</span>
      </div>
    </div>

    <div class="handoff-list-header">
      <span>Available destinations</span>
      <strong>{{ transferableAgents.length }}</strong>
    </div>

    <div class="agent-dialog-list handoff-list">
      <button type="button" class="handoff-agent-row" *ngFor="let agent of transferableAgents" (click)="handleTransfer(agent.ext, agent.name)">
        <span class="handoff-avatar">{{ initials(agent.name || agent.ext) }}</span>
        <span class="handoff-agent-main">
          <strong>{{ agent.name || ('Ext ' + agent.ext) }}</strong>
          <small>Extension {{ agent.ext }}</small>
        </span>
        <span class="handoff-status" [class.available]="agent.status === 'Available'">{{ agent.status }}</span>
        <span class="handoff-action">Transfer</span>
      </button>
      <div class="handoff-empty" *ngIf="!transferableAgents.length">
        No eligible agent extensions are available.
      </div>
    </div>
  </div>
</div>

<div class="agent-dialog-backdrop" *ngIf="showConference" (click)="showConference = false">
  <div class="agent-dialog handoff-dialog" role="dialog" aria-modal="true" aria-labelledby="conference-dialog-title" (click)="$event.stopPropagation()">
    <div class="agent-dialog-header">
      <div class="agent-dialog-title">
        <span class="material-icons">group_add</span>
        <div>
          <p>Live conference</p>
          <h3 id="conference-dialog-title">Add participant</h3>
        </div>
      </div>
      <button type="button" class="agent-dialog-close" (click)="showConference = false" aria-label="Close conference dialog">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="handoff-summary conference">
      <span class="material-icons">groups</span>
      <div>
        <p>Conference bridge</p>
        <strong>{{ activeCallerName || 'Current caller' }}</strong>
        <span>{{ conferenceParticipants.length || 1 }} participant{{ (conferenceParticipants.length || 1) === 1 ? '' : 's' }} active</span>
      </div>
    </div>

    <div class="handoff-list-header">
      <span>Add agent to bridge</span>
      <strong>{{ transferableAgents.length }}</strong>
    </div>

    <div class="agent-dialog-list handoff-list">
      <button type="button" class="handoff-agent-row" *ngFor="let agent of transferableAgents" (click)="handleConference(agent.ext, agent.name)">
        <span class="handoff-avatar">{{ initials(agent.name || agent.ext) }}</span>
        <span class="handoff-agent-main">
          <strong>{{ agent.name || ('Ext ' + agent.ext) }}</strong>
          <small>Extension {{ agent.ext }}</small>
        </span>
        <span class="handoff-status" [class.available]="agent.status === 'Available'">{{ agent.status }}</span>
        <span class="handoff-action">Add</span>
      </button>
      <div class="handoff-empty" *ngIf="!transferableAgents.length">
        No eligible agent extensions are available.
      </div>
    </div>
  </div>
</div>

<div class="agent-dialog-backdrop" *ngIf="showDial" (click)="showDial = false">
  <div class="agent-dialog" role="dialog" aria-modal="true" aria-labelledby="dial-dialog-title" (click)="$event.stopPropagation()">
    <div class="agent-dialog-header">
      <h3 id="dial-dialog-title">Make outbound call</h3>
      <button type="button" class="agent-dialog-close" (click)="showDial = false" aria-label="Close outbound call dialog">
        <span class="material-icons">close</span>
      </button>
    </div>
    <input
      class="agent-dialog-input"
      type="text"
      [ngModel]="dialPadValue || dialInput"
      (ngModelChange)="syncDialInput($event)"
      placeholder="Extension or phone number"
    />
    <button class="agent-dialog-primary" type="button" (click)="handleDial()">
      Call now
    </button>
  </div>
</div>
